<template>
    <div>
        <Breadcrumbs title="Queue Management" />
        <div class="container-fluid">
            <div class="d-flex justify-content-end">
                <transition name="fade">
                    <b-button v-if="selectedRows.length >= 2" @click="deleteSelectedRows" class="border-0 p-0 mr-1 mb-2"
                        style="background: #d8464d">
                        <div class="d-flex justify-content-center align-items-center add-btn w-100 h-100 px-3 py-1"
                            style="border-radius: 0.3em; background: #d8464d">
                            <font-awesome-icon icon="fa-solid fa-trash" class="mr-2" />
                            <!-- <i class="icofont icofont-plus-circle mr-2"></i> -->
                            <span style="font-size: 1em; color: #fff">Delete Queue</span>
                        </div>
                    </b-button>
                </transition>
                <b-button class="border-0 p-0 mr-0 mb-2" style="background: #287cfb" v-b-modal.addqueue>
                    <div class="d-flex justify-content-center align-items-center add-btn w-100 h-100 px-3 py-1"
                        style="border-radius: 0.3em; background: #287cfb">
                        <i class="icofont icofont-plus-circle mr-2"></i>
                        <span style="font-size: 1em; color: #fff">Add New Queue</span>
                    </div>
                </b-button>
            </div>
            <!-- :editData="editData" -->
            <addQueue ref='addQueue' :member='member' @addNewQue="addNewQue" @editQue="editQue" />
            <div class="card p-4">
                <div>
                    <dataTableVue ref="refDataTable" :isShowSelect="true" :isSearch2="true" :isSearch="false"
                        :isExport="false" :isFilter="false" :renderMode="'csr'" @load="loadItems" v-bind:data="{
                        columns: columns,
                        rows: rows,
                        rowCustom: 'rowQueueManagement',
                    }" @deleteRow="deleteRow" @editRow="editRow" @editToggle="editQue" @itemSelect="itemSelect" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { requestService } from '../../_services';
import addQueue from '../../components/queue-management/add-queue.vue';
export default {
    components: {
        addQueue,
    },
    data() {
        return {
            perPage: 50,
            // editData: null,
            search: '',
            editRuleData: null,
            selectedRows: [],
            columns: [
                // {
                //     label: '',
                //     field: 'checkbox',
                //     sortable: false,
                //     hidden: false,
                //     width: '5%',
                // },
                {
                    label: 'Queue Name',
                    field: 'name',
                    sortable: false,
                    hidden: false,
                    width: '15%',
                },
                {
                    label: 'Members',
                    field: 'member',
                    sortable: false,
                    hidden: false,
                },
                {
                    label: 'Status',
                    field: 'status',
                    width: '10%',
                    sortable: false,
                    hidden: false,
                },
                {
                    label: 'Action',
                    field: 'action',
                    width: '10%',
                    sortable: false,
                    hidden: false,
                },
            ],
            rows: [],
            rows2: [],
            currentPage: 1,            // rows: [
            //     {
            //         id: 1,
            //         isCheck: false,
            //         name: 'Queue1',
            //         status: false,
            //         members: 'Tansika, Panapol, Tawan',
            //     },
            //     {
            //         id: 2,
            //         isCheck: false,
            //         name: 'Queue2',
            //         status: true,
            //         members: 'Tansika, Tawan, Kanokpon, Kittipan',
            //     },
            //     {
            //         id: 3,
            //         isCheck: false,
            //         name: 'Queue3',
            //         status: false,
            //         members: 'Tawan, Kanokpon, Kittipan, Worawiboon, Tawat',
            //     },
            //     {
            //         id: 4,
            //         isCheck: false,
            //         name: 'Queue4',
            //         status: true,
            //         members: 'Worawiboon, Tawat, Sahatsawat, Rinalpad',
            //     },
            //     {
            //         id: 5,
            //         isCheck: false,
            //         name: 'Queue5',
            //         status: false,
            //         members: 'Supasuta, Nuchjarin, Kannikar, Kanokpon',
            //     },
            // ],
            // rows2: [
            //     {
            //         id: 1,
            //         isCheck: false,
            //         name: 'Queue1',
            //         status: false,
            //         members: 'Tansika, Panapol, Tawan',
            //     },
            //     {
            //         id: 2,
            //         isCheck: false,
            //         name: 'Queue2',
            //         status: true,
            //         members: 'Tansika, Tawan, Kanokpon, Kittipan',
            //     },
            //     {
            //         id: 3,
            //         isCheck: false,
            //         name: 'Queue3',
            //         status: false,
            //         members: 'Tawan, Kanokpon, Kittipan, Worawiboon, Tawat',
            //     },
            //     {
            //         id: 4,
            //         isCheck: false,
            //         name: 'Queue4',
            //         status: true,
            //         members: 'Worawiboon, Tawat, Sahatsawat, Rinalpad',
            //     },
            //     {
            //         id: 5,
            //         isCheck: false,
            //         name: 'Queue5',
            //         status: false,
            //         members: 'Supasuta, Nuchjarin, Kannikar, Kanokpon',
            //     },
            // ],
            member: []
        };
    },

    async mounted() {
        await this.getMember()
        // await this.loadItems();
    },

    methods: {
        getMember() {
            var url = '/api/mail/ccp_user';
            requestService.GetFetch('ccp', url).then((res) => {
                if (res.status == 200) {
                    res.text().then((text) => {
                        const data = text && JSON.parse(text);
                        // console.log('data: ', data.data)
                        this.member = data.data
                    });
                    this.loadItems()
                }
            });
        },
        loadItems(e) {
            // console.log('e: ', e)
            if (e != undefined) {
                this.searchData(e.search)
                if (e.params.limit != this.perPage) {
                    this.perPage = e.params.limit
                    this.loadItems()
                } else if (e.params.page != this.currentPage) {
                    this.currentPage = e.params.page
                    this.loadItems()
                }
            } else {
                let url = `/api/mail/queue_management?page=${this.currentPage}&limit=${this.perPage}`;
                requestService
                    .GetFetch('ccp', url)
                    .then((res) => {
                        if (res.status == 200) {
                            res.text().then((text) => {
                                const data = text && JSON.parse(text);
                                const mappedData = data.data.map(item => {
                                    const memberNames = item.member.map(memberId => {
                                        const matchedMember = this.member.find(obj => obj._id === memberId);
                                        return matchedMember ? matchedMember.name : null;
                                    });
                                    return { ...item, memberNames };
                                });
                                this.rows = mappedData;
                                this.rows2 = mappedData;
                            });
                        }
                    })
                    .catch((err) => {
                        console.log('err: ', err);
                    });
            }
        },
        deleteSelectedRows() {
            this.$swal
                .fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2971FF',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.selectedRows.forEach((e) => {
                            this.deleteMultiRow(e)
                        })

                    }
                });

        },
        deleteMultiRow(item) {
            let url = `/api/mail/queue_management/${item._id}`;
            requestService
                .DeleteFetch('ccp', url)
                .then(() => {
                    this.loadItems()
                })
                .catch((err) => {
                    // this.$swal.fire({
                    //     icon: 'error',
                    //     title: 'Try Again',
                    //     text: err,
                    // });
                });
        },
        itemSelect(e) {
            this.selectedRows = e.selectedRows;
            // console.log('itemSelect: ', this.selectedRow)
        },
        // editToggle(e) {
        //     this.editQue(e)
        // },
        editQue(payload) {

            let url = `/api/mail/queue_management/${payload._id}`;
            requestService
                .PutFetch('ccp', url, payload)
                .then((res) => {
                    if (res.status == 200) {
                        res.text().then((text) => {
                            const data = text && JSON.parse(text);
                            // console.log('put: ', data, res);
                            this.loadItems()
                        });
                    }
                })
                .catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                    });
                });
        },
        addNewQue(payload) {
            let url = `/api/mail/queue_management`;
            requestService.PostFetch('ccp', url, payload).then((res) => {
                if (res.status == 200) {
                    res.text().then((text) => {
                        const data = text && JSON.parse(text);
                        // console.log('add: ', data, res)
                        this.loadItems()
                    })
                }
            }).catch((err) => {
                console.log('err: ', err)
                this.$swal.fire({
                    icon: 'error',
                    title: 'Try Again',
                    text: err,
                });
            })
            // this.rows2.push(payload)
        },
        editRow(e) {
            this.$refs.addQueue.editData = e
            // this.editData = e;
        },
        deleteRow(item) {
            // console.log(item)
            this.$swal
                .fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2971FF',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        let url = `/api/mail/queue_management/${item._id}`;
                        requestService
                            .DeleteFetch('ccp', url)
                            .then(() => {
                                this.rows = this.rows.filter((element) => {
                                    return element.id != item.id;
                                });
                                this.$swal.fire(
                                    'Deleted!',
                                    'Your file has been deleted.',
                                    'success'
                                );
                                this.loadItems();
                            })
                            .catch((err) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'Try Again',
                                    text: err,
                                });
                            });
                    }
                });
        },
        searchData(input) {
            // console.log('search: ', input);
            if (input == '') {
                this.rows = this.rows2;
            } else {
                this.rows = this.rows2;
                this.rows = this.rows.filter((row) =>
                    row.name.toLowerCase().includes(input.toLowerCase())
                );
            }
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
    transform: translateX(0px);
    opacity: 0;
}

.searchIcon {
    position: relative;
    top: 0.7em;
    left: 2.5em;
}

.container-fluid {
    font-size: 10px;
}
</style>
